import { createSlice, PayloadAction } from "@reduxjs/toolkit";


type TDashboardNodeType = 'tree' | 'inBox';

interface IInitialState{
    dashboardNodeType: TDashboardNodeType
}

const defaultDashboardRadioBtnState:TDashboardNodeType = 'tree'

const initialState:IInitialState = {
    dashboardNodeType: defaultDashboardRadioBtnState
}

const dashboardNodeTypeSlice = createSlice({
    name: 'dashboardNodeType',
    initialState,
    reducers:{
        setDashboardNodeType: ((state: IInitialState, action: PayloadAction<TDashboardNodeType>)=>{
            state.dashboardNodeType = action.payload;
        }),

        resetDashboardNodeType: ((state: IInitialState)=>{
            state.dashboardNodeType = defaultDashboardRadioBtnState
            
        })
    }
})

export default dashboardNodeTypeSlice.reducer;
export const {setDashboardNodeType, resetDashboardNodeType} = dashboardNodeTypeSlice.actions;